import api from 'api'
import useSWR from 'swr'

/**
 * idをもとにOwnerを取得するSWR
 */
export const useOwnerEvents = ({
  ownerId,
  limit,
}: {
  ownerId?: string
  limit?: number
}) => {
  const keys = [ownerId ? `/owners/${ownerId}/events` : null, limit]
  return useSWR<EventCardType[]>(
    keys,
    (path) =>
      api
        .get(path, {
          params: { limit: limit },
        })
        .then((res) => res.data),
    {
      revalidateOnFocus: false,
    },
  )
}
